// extracted by mini-css-extract-plugin
export default {"NotFound":"NotFound_NotFound__+B8to","container":"NotFound_container__EbbMl","info":"NotFound_info__Me3Ki","task":"NotFound_task__sH8fZ"};